/* Satirical Coffee - "Ask the library" typed / dictated question (G1.2 owner-only CANDIDATE). NEW FILE, not applied anywhere.
   Loaded by the section only when "typed_input" is on (default off). Replaces scc-library-ask.js on that section; never both.
   ONE route for every way of asking: typed text, dictated-then-confirmed text and the example buttons all go through ask() below to the same signed v2 route.
   The microphone (separate file) only fills the text box; nothing is sent until the visitor presses Ask. No audio ever leaves the page from this file.
   Renders only answer text + source TITLES (textContent), no HTML insertion. No storage, no retries.
   Announces each rendered answer to the branded Listen module with a DOM event (text + opaque token). There is no device-speech code anywhere in this file. */
(function () {
  'use strict';
  var FALLBACK = "The library cannot answer right now. The written guides above still work.";
  var contract = window.SCCReviewedLibraryContract;
  var roots = document.querySelectorAll('[data-scc-reviewed-library]');
  if (!roots.length) return;
  var transport = null;
  if (contract && typeof window.fetch === 'function') {
    try { transport = contract.createTransport({ enabled: true, endpoint: '/apps/beanify/library/v2/ask', fetchFn: window.fetch.bind(window), timeoutMs: 15000, allowLinks: true }); } catch (e) { transport = null; }
  }
  function el(tag, text, cls) { var n = document.createElement(tag); if (text) n.textContent = text; if (cls) n.className = cls; return n; }
  function announce(root, detail) {
    try { root.dispatchEvent(new CustomEvent('scc-reviewed-answer', { bubbles: false, detail: detail })); } catch (e) { /* the page still shows the written answer */ }
  }
  Array.prototype.forEach.call(roots, function (root) {
    var out = root.querySelector('[data-ask-out]');
    var form = root.querySelector('[data-typed-form]');
    var field = root.querySelector('[data-typed-field]');
    var send = root.querySelector('[data-typed-send]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-ask-question]'));
    var page = root.getAttribute('data-page') || 'beverage_lab';
    var loginUrl = root.getAttribute('data-login-url') || '';
    if (!out || !form || !field || !send) return;
    var gen = 0, busy = false, mode = 'typed', dictated = '';
    function lock(on) { busy = on; send.disabled = on; chips.forEach(function (b) { b.disabled = on; }); }
    if (transport) lock(false);
    root.addEventListener('scc-reviewed-unused-dictation', function (ev) {                    /* from the microphone module: transcript text only, already placed in the box */
      mode = 'dictated'; dictated = field.value; if (ev && ev.detail && typeof ev.detail.text === 'string') { dictated = ev.detail.text; }
    });
    field.addEventListener('input', function () { if (mode === 'dictated' && field.value !== dictated) mode = 'dictated_edited'; if (!field.value) mode = 'typed'; });
    function paragraphs(text) { return String(text).split(/\n{2,}/).map(function (s) { return s.trim(); }).filter(Boolean); }
    function srcs(list) {
      var q = el('p', 'Sources: ', 'scc-lask__src');
      list.forEach(function (x, i) {
        if (i) q.appendChild(document.createTextNode(' | '));
        var u = typeof x.link === 'string' && /^https:\/\/[^\s"<>]+$/.test(x.link) ? x.link : null;
        if (u) { var a = el('a', x.title); a.setAttribute('href', u); a.setAttribute('target', '_blank'); a.setAttribute('rel', 'noopener noreferrer nofollow'); q.appendChild(a); }
        else q.appendChild(document.createTextNode(x.title));
      });
      return q;
    }
    function render(p) {
      out.textContent = '';
      if (p.state==='answered' && p.character && p.character.display) out.appendChild(el('p', 'From '+p.character.display, 'scc-lask__src'));
      if (p.matched_question) out.appendChild(el('p', 'Answering: ' + p.matched_question, 'scc-lask__src'));
      paragraphs(p.answer).forEach(function (para) { out.appendChild(el('p', para, 'scc-lask__ans')); });
      if ((p.state === 'answered' || p.state === 'recommendation') && p.sources.length) {
        if (p.state === 'recommendation') {
          var lib = p.sources.filter(function (x) { return x.kind === 'library'; }).map(function (x) { return x.title; });
          var store = p.sources.filter(function (x) { return x.kind === 'store'; }).map(function (x) { return x.title; });
          out.appendChild(el('p', 'Reviewed notes: ' + lib.join(' | ') + '. Availability checked for: ' + store.join(' | ') + '.', 'scc-lask__src'));
        } else {
          out.appendChild(srcs(p.sources));
        }
      }
      if (p.suggestions && p.suggestions.length) {
        var row = el('div', null, 'scc-lask__sugg');
        p.suggestions.forEach(function (t) {
          var b = el('button', t, 'scc-lask__q'); b.type = 'button';
          b.addEventListener('click', function () { if (busy) return; field.value = t; mode = 'typed'; ask(t, 'example_chip'); });
          row.appendChild(b);
        });
        out.appendChild(row);
      }
      if (p.state === 'authentication_required' && loginUrl) { var q = el('p'), a = el('a', 'Sign in'); a.setAttribute('href', loginUrl); q.appendChild(a); out.appendChild(q); }
    }
    function ask(text, inputMode) {
      text = String(text || '').trim();
      if (!text || busy) return;
      if (!transport) { out.textContent = ''; out.appendChild(el('p', FALLBACK)); announce(root, { state: 'none' }); return; }
      var my = ++gen, started = Date.now();
      lock(true); out.textContent = ''; out.appendChild(el('p', 'Looking that up…')); announce(root, { state: 'none' });
      transport.ask({ v: 2, question: text.slice(0, 500), input_mode: inputMode, page: page }).then(function (p) {
        if (my !== gen) return;
        out.removeAttribute('data-ask-diag');
        if (p.state === 'pending' || p.state === 'queued') throw Object.assign(new Error('unexpected'), { code: 'unexpected_state' });
        render(p);
        var v = p.character && p.character.voice;
        announce(root, { state: p.state, text: paragraphs(p.answer).join('\n\n'), character: p.character && p.character.id, display: p.character && p.character.display,
          voice: (p.state === 'answered' && v && v.available === true && typeof v.answer_token === 'string') ? { token: v.answer_token } : null });
      }, function (err) { throw err; }).catch(function (err) {
        if (my !== gen) return;
        var code = err && /^[a-z_]{2,32}$/.test(String(err.code)) ? err.code : 'other';
        var st = err && typeof err.status === 'number' && err.status >= 100 && err.status <= 599 ? ':' + err.status : '';
        out.setAttribute('data-ask-diag', code + st + ':' + Math.max(0, Date.now() - started) + 'ms');     /* reason + status + elapsed only: never the question or the reply */
        out.textContent = ''; out.appendChild(el('p', FALLBACK)); announce(root, { state: 'none' });
      }).then(function () { if (my === gen) { lock(false); mode = 'typed'; dictated = ''; out.focus(); } });
    }
    form.addEventListener('submit', function (ev) { ev.preventDefault(); ask(field.value, mode); });
    chips.forEach(function (b) { b.addEventListener('click', function () { if (b.disabled) return; field.value = b.getAttribute('data-ask-question'); mode = 'typed'; ask(field.value, 'example_chip'); }); });
  });
}());
